import { useState } from "react";
import { IonModal, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonContent } from "@ionic/react";
import { closeOutline, checkmarkOutline } from "ionicons/icons";

// The admin "edit in a sheet" modal (Settings, Site Settings): the picker-modal
// chrome with the close X on the left and the green checkmark on the right,
// which saves. No Save button in the body. Mount it fresh per open (render it
// conditionally) so it always presents.
//
// props: title, onClose (X / backdrop), onSave (checkmark), saving, saveLabel, children
export default function EditSheet({ title, onClose: onCloseNow, onSave, saving, children, saveLabel = "Save", className = "" }) {
  // The X and backdrop flip isOpen first, so the sheet plays its leave
  // animation; the parent unmounts it from onDidDismiss afterwards.
  const [shutting, setShutting] = useState(false);
  const onClose = () => setShutting(true);
  return (
    <IonModal isOpen={!shutting} onDidDismiss={() => onCloseNow?.()} className={`admin-detail-modal admin-edit-sheet ${className}`.trim()}>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={onClose} aria-label="Close"><IonIcon icon={closeOutline} slot="icon-only" /></IonButton>
          </IonButtons>
          <IonTitle>{title}</IonTitle>
          <IonButtons slot="end">
            <IonButton fill="clear" shape="round" onClick={onSave} disabled={saving} title={saveLabel} aria-label={saveLabel} className="edit-sheet-save">
              <span slot="icon-only" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", lineHeight: 0, flexShrink: 0, fontSize: "1rem", color: "var(--ion-color-success)" }}>
                <IonIcon icon={checkmarkOutline} className="bold-icon" style={{ fontSize: "inherit", color: "inherit", pointerEvents: "none" }} />
              </span>
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div style={{ padding: "18px 16px 22px", display: "flex", flexDirection: "column", gap: 14 }}>
          {children}
        </div>
      </IonContent>
    </IonModal>
  );
}
